import cardsEstate from "@/js/components/cards/_estate.js";
import buttonsFavorite from "@/js/components/buttons/_favorite.js";
import formsHScrollBar from "@/js/components/forms/_h-scroll-bar.js";

/**
 * TOP「おすすめ物件」カードリスト（pages.home._pickup-cards）の後始末。
 *
 * カードリストは LoadContents プラグインが innerHTML で差し込むため、
 * ページ初期化時（components/index.js）に走った初期化はこのカード群を見ていない。
 * innerHTML 代入ではインライン <script> も実行されないので、
 * 注入後に必要な処理はすべてここから既存の初期化関数を呼び直す形で面倒をみる。
 *
 * 再実行する初期化（いずれも二重登録しないよう要素側にフラグを持つ）:
 *  - components/cards/_estate.js      … カード全面クリックで詳細へ
 *  - components/buttons/_favorite.js  … お気に入りボタン（Cookie/DBの状態復元とトグル）
 *  - components/forms/_h-scroll-bar.js… 総合TOPの横スクロール＋つまみ追従
 *
 * ここで呼ばないもの:
 *  - pages/home/pickup-gallery.js … document への委譲なので注入後のカードにも効く
 *  - pages/home/pickup-align.js   … 自前で onLoadContents を購読して再計算する
 */
const hideEmptyPickupSection = (loadEl) => {
    if (!loadEl) return;

    const hasEmptyMarker = Boolean(loadEl.querySelector("[data-pickup-empty]"));

    // 読み込み中は消さない（ローダーのみで list が無いため）。
    // 0件マーカーは innerHTML 差し替え直後に付くので、is-loading 残存中でも判定する。
    if (loadEl.classList.contains("is-loading") && !hasEmptyMarker) return;

    const isEmpty =
        hasEmptyMarker
        || (
            !loadEl.querySelector(".p-home-pickup__list, .p-home-pickup__item")
            && !loadEl.querySelector(".load-contents-loader")
        );

    if (!isEmpty) return;

    const section = loadEl.closest("[data-pickup-section], .p-home-pickup, #pickup");
    if (!section) return;
    section.hidden = true;
    section.setAttribute("aria-hidden", "true");
};

const setupPickupCards = (event) => {
    const loadEl = event?.currentTarget;
    hideEmptyPickupSection(loadEl);

    const section = loadEl?.closest?.("[data-pickup-section], .p-home-pickup, #pickup");
    if (section?.hidden) return;

    cardsEstate();
    buttonsFavorite();
    formsHScrollBar();
};

const homePickupCards = () => {
    // LoadContents は完了時にプレースホルダ上で onLoadContents を発火する
    // （バブルしないので要素に直接張る）
    document.querySelectorAll(".js-load-contents[data-pickup-cards]").forEach((el) => {
        el.addEventListener("onLoadContents", setupPickupCards);

        // 取得失敗時は onLoadContents が来ないため、is-load-error を監視して非表示にする
        const observer = new MutationObserver(() => {
            if (!el.classList.contains("is-load-error")) return;
            hideEmptyPickupSection(el);
            observer.disconnect();
        });
        observer.observe(el, { attributes: true, attributeFilter: ["class"] });
    });
};

export default homePickupCards;
